import { css } from '@emotion/react';

import {
  InitialLoadIconsSet,
  OtherIconsSet
} from 'src/utils/constants/IconsConstants';

import { colors } from '../../styles/colors';
import {
  getInitialLoadIcons,
  getOtherIcons,
  SetFontSize,
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const mainContainer = css`
  width: 100%;
`;

export const Subscription = css`
  background: ${colors.AppBgColor};
  padding: 24px 16px;
  border-radius: 20px 20px 0px 0px;
  padding-bottom: 0;
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  ${MQ.MediaSm} {
    display: block;
    min-height: 295px;
    height: auto;
  }
  ${MQ.MediaLg} {
    display: block;
    padding: 25px 40px;
  }
  & .termsOfUseLink {
    color: ${colors.PurpleLight};
  }
`;

export const planTitle = css`
  ${ZeeFontRegular(14)}
  line-height: 24px;
  color: ${colors.Grey88};
  width: 100%;
  overflow-wrap: break-word;
`;
export const discountedPrice = css`
  ${ZeeFontRegular(12)}
  line-height: 24px;
  text-decoration: line-through;
  color: ${colors.Grey88};
`;
export const price = css`
  ${ZeeFontRegular(18)}
  font-weight: 700;
  line-height: 24px;
`;
export const month = css`
  ${ZeeFontRegular(14)}
  line-height: 24px;
  color: ${colors.AccentSubscriptionCodGrayColor};
`;
export const planBox = css`
  border: 1.5px solid ${colors.ComboPopupSubtitleGray};
  border-radius: 8px;
  text-align: center;
  color: ${colors.white};
  ${SetFontSize(12, 16)}
  min-width: 89px;
  width: 100%;
  ${MQ.MediaSm} {
    max-width: 172px;
    ${SetFontSize(14, 20)}
  }
  ${MQ.MediaLg} {
    min-width: 165px;
    max-width: 165px;
    ${SetFontSize(14, 20)}
  }
`;
export const applyCodeBox = css`
  background: ${colors.SearchCardBg};
  border-radius: 8px;
  padding: 9px 11px;
  margin-bottom: 24px;
  color: ${colors.white};
  ${SetFontSize(12, 18)}
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)}
  }
`;
export const applyCode = css`
  display: flex;
  gap: 6px;
  flex: 1;
  align-items: center;
`;

export const description = css`
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  ${ZeeFontMedium(12, 18)};
`;
export const paymentMethods = css`
  background: ${colors.SearchCardBg};
  padding: 12px 16px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  color: ${colors.white};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  ${MQ.MediaLg} {
    padding: 22px 40px;
    position: relative;
  }
  & svg {
    margin-left: 7px;
  }
`;
export const loginTextContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  ${MQ.MediaMd} {
    display: none;
  }
  & .userEmailMobile {
    color: ${colors.PurpleLight};
    padding-left: 5px;
  }
`;
export const flexSpaceBetween = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const loginDiv = css`
  color: ${colors.InputBorder};
  ${ZeeFontRegular(14, 20)};
  text-align: center;
  ${MQ.MediaLg} {
    margin-bottom: 24px;
  }
`;
export const loginText = css`
  cursor: pointer;
  color: ${colors.PurpleLight};
  & .userEmailMobile {
    color: ${colors.PurpleLight};
    padding-left: 5px;
  }
`;

export const payment = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${MQ.MediaLg} {
    flex: 2;
    padding-right: 8px;
  }
`;
export const paymentMode = css`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  color: ${colors.NewSubscriptionCouponText};
  ${ZeeFontBold(14, 20)}
  ${MQ.MediaLg} {
    ${ZeeFontBold(16, 22)}
  }
`;
export const Button = css`
  padding: 14px 34px;
  background: ${colors.PurpleCl};
  border-radius: 6px;
  ${ZeeFontRegular(14, 20)}
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${colors.PurpleCl};
  color: ${colors.white};
  cursor: pointer;
  flex: 1;
  ${MQ.Media400} {
    ${ZeeFontRegular(14, 22)}
    padding: 10px;
  }
  ${MQ.MediaSm} {
    ${ZeeFontRegular(14, 22)}
    padding: 12px 10px;
  }
  ${MQ.MediaLg} {
    flex: 5;
  }
`;

export const tableSpacing = css`
  border-collapse: collapse;
  border-spacing: 0;
`;
export const OfferBox = css`
  ${ZeeFontRegular(8, 11)}
  background: ${colors.EduBlue};
  border-radius: 6px 3px 3px 0;
  color: ${colors.PrimaryWhiteColor};
  z-index: 99;
  padding: 0px 2px;
  position: absolute;
  ${MQ.MediaSm} {
    ${ZeeFontRegular(10, 18)}
  }
`;

export const shimmer = css`
  animation: shimmer 2s infinite linear;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 50%,
    rgb(109 102 165 / 90%) 100%
  );
  background-size: 1000px 100%;
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }
`;

export const suggested = css`
  ${ZeeFontRegular(10, 22)}
  border-radius: 3px 3px 0 0;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  color: ${colors.white};
  left: 25%;
  padding: 2px 10px;
  position: absolute;
  top: -22px;
  line-height: 18px;
  border-radius: 3px 3px 0px 0px;
  ${MQ.MediaSm} {
    left: 30%;
  }
`;

//--------//---------Flex table--------//--------//

export const table = css`
  color: ${colors.white};
  padding-bottom: 40px;
  height: 50%;
  overflow-y: auto;
  -webkit-mask-image: linear-gradient(
    180deg,
    ${colors.black} 90%,
    ${colors.Transparent}
  );
  ${MQ.MediaLg} {
    height: 295px;
    max-height: 295px;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
export const flexTable = css`
  display: flex;
  justify-content: flex-start;
  min-height: 44px;
  ${MQ.MediaSm} {
    min-height: 50px;
  }
  & + div:last-child .plan-selected {
    padding-bottom: 20px;
    border-radius: 0 0 12px 12px;
    ${MQ.MediaLg} {
      padding-bottom: 55px;
    }
  }

  ${MQ.MediaLg} {
    &:not(:first-of-type) {
      border-bottom: 0.5px solid ${colors.SubscriptionPlansBorderBottom};
    }
  }
  &:last-child {
    border-bottom: none;
  }
`;
export const tableTitle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0.5;
  ${MQ.MediaSm} {
    flex: 0.8;
  }
`;

export const tableHeader = css`
  title: 'tableHeader';
  display: flex;
  text-align: center;
  flex: 1.2;
  ${ZeeFontMedium(12, 16)};
  min-width: 190px;
  ${MQ.MediaLg} {
    flex: 1;
    height: 30px;
    height: 52px;
    ${ZeeFontMedium(14, 22)};
  }
`;

export const tablePlans = css`
  display: flex;
  text-align: center;
`;

export const planValue = css`
  width: 100%;
  padding: 1px;
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  min-height: 30px;
  ${ZeeFontMedium(11, 18)};
  ${MQ.MediaLg} {
    ${ZeeFontMedium(14, 22)};
    min-height: 52px;
    border-bottom: 0.5px solid ${colors.SubscriptionPlansBorderBottom};
  }
`;
export const featureTitle = css`
  ${planValue};
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 30px;
  ${MQ.MediaMaxWidth480} {
    padding-right: 10px;
  }
`;
export const featureSubTitle = css`
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  ${ZeeFontMedium(10, 18)};
  ${MQ.MediaLg} {
    ${ZeeFontMedium(12, 18)};
  }
`;
export const subscriptionPlanValue = css`
  ${planValue}
  width:75px;
  gap: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${MQ.Media400} {
    width: 86px;
  }
  ${MQ.MediaLg} {
    width: 116px;
  }
`;
export const planTitleValue = css`
  ${planValue};
  ${ZeeFontBold(12, 18)};
  border-bottom: 0;
  width: 75px;
  height: 52px;
  overflow-wrap: break-word;
  text-align: center;
  padding: 12px 10px;
  ${MQ.Media400} {
    width: 86px;
    padding: 12px;
  }
  ${MQ.MediaLg} {
    border-bottom: 0;
    width: 116px;
    overflow-wrap: break-word;
    ${ZeeFontBold(14, 22)};
  }
`;

export const mainContent = css`
  color: ${colors.Grey88};
  ${ZeeFontMedium(11, 18)};
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
`;

export const subContent = css`
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  ${ZeeFontRegular(10, 14)};
  ${MQ.MediaSm} {
    ${ZeeFontRegular(12, 18)};
  }
`;
export const tickIcon = css`
  ${getOtherIcons(OtherIconsSet.TICK)}
  &:before {
    font-weight: 700;
  }
`;
export const rightArrowIcon = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.RIGHT_CHEVRON)}
  ${SetFontSize(15)}
  font-weight: 500;
`;
export const topArrowIcon = css`
  ${getOtherIcons(OtherIconsSet.TOP_CHEVRON)}
  ${SetFontSize(25)}
  font-weight: 700;
`;
export const planDataTickIcon = css`
  ${tickIcon}
  font-size: 20px;
`;

export const planDataCrossIcon = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.CLOSE)}
  ${SetFontSize(20)}
  &:before {
    font-weight: 700;
  }
  ${MQ.MediaLg} {
    ${SetFontSize(30)}
  }
`;

export const featureTitleWrapper = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${MQ.MediaMaxWidth480} {
    flex-basis: 35%;
  }
  ${MQ.MediaMd} {
    flex-basis: 40%;
  }
`;
export const subscriptionPlansWrapper = css`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  margin-left: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;
export const planContainer = css`
  display: flex;
  flex-direction: column;
  &.plan-selected {
    background: ${colors.SubscriptionPlansBorderBottom};
    border-radius: 12px;
  }
`;
